const developMain = {
  title: 'РОЗВИВАЙ УКРАЇНСЬКЕ З НАМИ',
  description:
    'Ми шукаємо тих, хто хоче розвивати українські оборонні технології, створювати інноваційні рішення для захисників і рухати нашу спільну перемогу вперед.',
  button: {
    team: 'СТАТИ ЧАСТИНОЮ КОМАНДИ',
    partner: 'СТАТИ ПАРТНЕРОМ',
  },
}

export default developMain
